import type { DashboardStatsQuery, FailReasonVoiceProviderFilter } from "@/types";

/** Base query params for dashboard case-scoped APIs (stats, transition-retry, etc.). */
export function buildStatsQueryParams(q: DashboardStatsQuery): URLSearchParams {
  const p = new URLSearchParams();
  if (q.product?.trim()) p.set("product", q.product.trim());
  if (q.bin?.trim()) p.set("bin", q.bin.trim());
  if (q.pcn?.trim()) p.set("pcn", q.pcn.trim());
  if (q.from?.trim()) p.set("from", q.from.trim());
  if (q.to?.trim()) p.set("to", q.to.trim());
  return p;
}

export function appendFailReasonVoiceProviderFilter(
  params: URLSearchParams,
  voiceProvider: FailReasonVoiceProviderFilter = "all",
): URLSearchParams {
  if (voiceProvider !== "all") {
    params.set("voice_provider", voiceProvider);
  }
  return params;
}

/** Query string for GET /api/dashboard/analytics-bundle (case filters + path tokens). */
export function buildAnalyticsBundleQueryParams(
  q: DashboardStatsQuery,
  fromStatuses: string[],
  toStatuses: string[],
): URLSearchParams {
  const p = buildStatsQueryParams(q);
  for (const x of fromStatuses) {
    if (x?.trim()) p.append("from_status", x.trim());
  }
  for (const x of toStatuses) {
    if (x?.trim()) p.append("to_status", x.trim());
  }
  return p;
}
